/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';

export type ZerogTrxInfo = {
    TRXHA: string;
    STAT: ZerogTrxInfo.STAT;
    MTH: string;
    BNO: string;
    AG: string;
    ADDRSFROMINFO: EvmAddressSummaryInfo;
    ADDRSTOINFO: EvmAddressSummaryInfo;
    AMT: string;
    VAL: string;
    TRXF: string;
    TRXFVAL: string;
    UT: number;
    TRXID: string;
    SNO: string;
};

export namespace ZerogTrxInfo {

    export enum STAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }


}

